// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import App from './data'

export default function AppFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/App">
      {typeof children === 'function' ? (
        children({
          children: <App {...props} viewPath="/App" />,
          viewPath: "/App"
        })
      ) : (
        <App {...props}>
        {children}
      </App>
      )}
    </Flow>
  )
}
